import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * iter191 — Route değişikliğinde sayfayı en tepeye (0,0) sıfırlar.
 * - Hash (#id) varsa ilgili elemente kaydırır, yoksa top'a atlar.
 * - Anlık (behavior: "instant") — smooth kaymanın alta iniyor gibi görünmesini önler.
 * - Tarayıcının scrollRestoration'ını manuel'a alır (geri/ileri butonunda konumu React yönetsin).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      try { window.history.scrollRestoration = "manual"; } catch {}
    }
  }, []);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ block: "start" });
        return;
      }
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}
